import React, { useEffect, useState } from "react";
import axios from "axios";
import { showSnackbar } from "../../../comopnents/snackbar";
import { getSettings, updateSettings } from "../../../services/apiService";

const ValueSettings = () => {
  const [settings, setSettings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingId, setEditingId] = useState(null);
  const [editValue, setEditValue] = useState("");

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      setLoading(true);

      const response = await getSettings();

      console.log("Settings response:", response);

      if (response?.status) {
        setSettings(response.data || []);
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
      showSnackbar("Failed to fetch settings", "error");
    } finally {
      setLoading(false);
    }
  };
  const handleEdit = (setting) => {
    setEditingId(setting.id);
    setEditValue(setting.value);
  };

  const handleCancel = () => {
    setEditingId(null);
    setEditValue("");
  };

  const handleSave = async (id) => {
    try {
      const setting = settings.find((item) => item.id === id);

      if (!setting) return;

      const payload = {
        id: setting.id,
        name: setting.name,
        value: Number(editValue),
        clientid: setting.clientid,
      };

      console.log("Update payload:", payload);

      const response = await updateSettings(payload);

      console.log("Update response:", response);

      if (response?.status) {
        setSettings((prev) =>
          prev.map((item) =>
            item.id === id
              ? {
                  ...item,
                  value: Number(editValue),
                }
              : item,
          ),
        );

        setEditingId(null);
        setEditValue("");

        showSnackbar(
          response.message || "Setting updated successfully",
          "success",
        );
      }
    } catch (error) {
      console.error("Error updating setting:", error);
      showSnackbar("Failed to update setting", "error");
    }
  };
  if (loading) {
    return (
      <div className="container-fluid py-4">
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="card shadow-sm border-0">
      <div className="card-body p-0">
        <div className="table-responsive">
          <table
            className="table table-hover align-middle mb-0"
            style={{ tableLayout: "fixed", width: "100%" }}
          >
            <thead className="table-light">
              <tr>
                <th style={{ width: "10%" }}>S.no</th>

                <th style={{ width: "25%" }}>Setting</th>

                <th style={{ width: "35%" }}>Value</th>

                <th className="text-center" style={{ width: "30%" }}>
                  Action
                </th>
              </tr>
            </thead>

            <tbody>
              {settings.length > 0 ? (
                settings.map((setting, index) => (
                  <tr key={setting.id}>
                    <td>{index + 1}</td>

                    <td>
                      <strong style={{ fontSize: "18px", fontWeight: "600" }}>
                        {setting.name}
                      </strong>
                    </td>

                    <td style={{ textAlign: "center" }}>
                      {editingId === setting.id ? (
                        <input
                          type="number"
                          className="form-control"
                          value={editValue}
                          onChange={(e) => setEditValue(e.target.value)}
                          style={{
                            width: "162px",
                            height: "36px",
                            margin: "0 auto",
                            textAlign: "center",
                          }}
                        />
                      ) : (
                        <span>{setting.value}</span>
                      )}
                    </td>
                    <td className="text-center">
                      {editingId === setting.id ? (
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{
                            gap: "8px",
                            minWidth: "150px",
                          }}
                        >
                          <button
                            className="btn btn-success"
                            style={{
                              padding: "5px 10px",
                              fontSize: "12px",
                              minWidth: "55px",
                            }}
                            onClick={() => handleSave(setting.id)}
                          >
                            Save
                          </button>

                          <button
                            className="btn btn-secondary"
                            style={{
                              padding: "5px 10px",
                              fontSize: "12px",
                              minWidth: "65px",
                              color: "black",
                            }}
                            onClick={handleCancel}
                          >
                            Cancel
                          </button>
                        </div>
                      ) : (
                        <button
                          className="btn btn-primary btn-sm"
                          style={{
                            minWidth: "90px",
                          }}
                          onClick={() => handleEdit(setting)}
                        >
                          Edit
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center py-4">
                    No settings found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ValueSettings;
